<template lang="pug">
  .container.content
    h1.has-text-light Доступные материалы
    .columns
      .column.is-4-desktop(v-for="lesson in lessons.items" :key="lesson.id")
        lesson-card(:lesson="lesson")

</template>

<script>
import Lesson from '@/models/Lesson';

export default {
  name: 'view-site-lessons-index',

  data: () => ({
    lessons: Lesson.collection(),
  }),

  created() {
    this.lessons.$fetch({ include: 'category' });
  },
};
</script>
